import React from 'react';
import { Text, View } from '@react-pdf/renderer';
import { styles } from './InvoiceFeeItem.styles';
import { displayPriceFormat } from '../../utils/tools';
import { PAYMENT_TYPE_STRIPE } from '../../constants/dataConfig';

const InvoiceFeeItem = ({
  serviceBillingItem,
  servicePrice,
  isDriverInvoice = false,
  serviceBillingItemKey,
  isDishopCreditor,
  subtotalHT
}) => {
  const { variable, total = 0, nbOrder = 0, fixe = parseFloat(fixe).toFixed(2) } = servicePrice;

  return (
    <View key={serviceBillingItemKey}>
      <View style={styles.positionRow}>
        {/* LEFT PART */}
        <View style={styles.leftPart}>
          {/* LIGNE 1 */}
          {!isDriverInvoice && (
            <View style={[styles.tableau]}>
              <Text style={styles.labelTab}>
                {isDishopCreditor
                  ? `Volume transitant TTC ${
                      serviceBillingItemKey === PAYMENT_TYPE_STRIPE ? '(Paiement en ligne)' : ''
                    }`
                  : 'Volume des paniers TTC'}
              </Text>
              <Text style={styles.labelTab}>{displayPriceFormat(total)}</Text>
            </View>
          )}
          {/* LIGNE 2 */}
          {(fixe || isDriverInvoice) && (
            <View style={[styles.tableau, styles.border]}>
              <Text style={styles.labelTab}>
                {isDriverInvoice
                  ? 'Frais de livraison'
                  : `Nombre de commandes
                  ${serviceBillingItemKey === PAYMENT_TYPE_STRIPE && ' (Paiement en ligne)'} `}
              </Text>
              <Text style={styles.labelTab}>{nbOrder}</Text>
            </View>
          )}
          {!fixe && !isDriverInvoice && <View style={[styles.separator, styles.border]} />}
          {serviceBillingItem.length > 1 && <View style={[styles.underTab, styles.border]} />}
        </View>
        {/* RIGHT PART */}
        <View style={styles.rightPart}>
          {/* LIGNE 1 */}
          {!isDriverInvoice && (
            <View style={[styles.tableau]}>
              <Text style={styles.labelTab}>{`${
                displayPriceFormat(variable).split(' ')[0]
              } %`}</Text>
              <Text style={styles.labelTab}>
                {displayPriceFormat(
                  subtotalHT - (!fixe || (fixe && subtotalHT < nbOrder * fixe) ? 0 : nbOrder * fixe)
                )}
              </Text>
            </View>
          )}
          {/* LIGNE 2 */}
          <View
            style={[fixe || isDriverInvoice ? styles.tableau : styles.separator, styles.border]}
          >
            {(fixe || isDriverInvoice) && (
              <>
                <Text style={styles.labelTab}>{displayPriceFormat(fixe)}</Text>
                <Text style={styles.labelTab}>{displayPriceFormat(nbOrder * fixe)}</Text>
              </>
            )}
          </View>

          {/* LIGNE 3 */}
          {serviceBillingItem.length > 1 && (
            <View style={[styles.underTab, serviceBillingItem.length > 1 ? styles.border : {}]}>
              <Text style={styles.labelTab}>
                {serviceBillingItem.length > 1 ? 'Sous ' : ''}Total HT
              </Text>
              <Text style={styles.labelTab}>{displayPriceFormat(subtotalHT)}</Text>
            </View>
          )}
        </View>
      </View>
    </View>
  );
};

export default InvoiceFeeItem;
